import { render, staticRenderFns } from "./InputSelect.vue?vue&type=template&id=b287de74&scoped=true"
import script from "./InputSelect.vue?vue&type=script&lang=js"
export * from "./InputSelect.vue?vue&type=script&lang=js"
import style0 from "./InputSelect.vue?vue&type=style&index=0&id=b287de74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b287de74",
  null
  
)

export default component.exports